import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/mad/layouts/default.vue").then(m => m.default || m))
}